import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "panel news-container"
}
const _hoisted_2 = ["datetime"]
const _hoisted_3 = ["innerHTML"]

import { onBeforeMount, ref } from 'vue';
import { getValueInUserLanguage } from '@/core/languageContent';
import { dateTime } from '@/core/date';
import { News, useNews } from '@/modules/news/News';


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardNewsList',
  setup(__props) {

const resource = useNews();
const news = ref<News[]>([]);

onBeforeMount(async () => {
	news.value = (await resource.getAll({
		limit: '3',
	})).data;
});

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (news.value.length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Nyheter", -1)
        ]))])), [
          [_directive_translate]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news.value, (newsItem) => {
          return (_openBlock(), _createElementBlock("article", {
            key: newsItem.id
          }, [
            _createElementVNode("h3", null, _toDisplayString(_unref(getValueInUserLanguage)(newsItem.content, 'headline')), 1),
            _createElementVNode("time", {
              datetime: newsItem.created_time
            }, _toDisplayString(_unref(dateTime)(newsItem.created_time)), 9, _hoisted_2),
            _createElementVNode("div", {
              innerHTML: _unref(getValueInUserLanguage)(newsItem.content, 'text')
            }, null, 8, _hoisted_3)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})